// @flow
import { fetchCartConfigurations } from '@gandi/cart';
import {
  selectors,
  actions,
  resources,
  templateResource,
} from '@gandi/template2';
import type { Template } from '@gandi/template2';

// @TODO: don't import from a private folder.
// eslint-disable-next-line @gandi/gandi/no-private-import
import type { DefaultTemplate } from '@gandi/template2/dist/types';

import { selectSetupOwner } from 'src/Cart/Setup/modules/selectors';
import type { CreateOrTransfer } from 'src/Cart/Setup/types';
import type { ThunkAction, Dispatch, GetState } from 'src/types';

import { selectTemplateIDForCurrentProducts } from './selectors';

export const getCurrentTemplate =
  ({
    process,
    productType,
  }: {
    process: CreateOrTransfer,
    productType: string,
  }): ThunkAction<Promise<Template | void>> =>
  async (dispatch, getState) => {
    let currentTemplateId = selectTemplateIDForCurrentProducts(getState(), {
      process,
      productType,
    });

    if (!currentTemplateId) {
      await dispatch(fetchCartConfigurations());
      currentTemplateId = selectTemplateIDForCurrentProducts(getState(), {
        process,
        productType,
      });
    }

    if (!currentTemplateId) {
      return undefined;
    }
    const label = currentTemplateId;

    let template = templateResource.selectDetail(getState(), label);
    if (!template) {
      await dispatch(
        templateResource.fetchOne(templateResource.options.fetchOnePath, {
          params: { id: currentTemplateId },
          label,
        }),
      );
      template = templateResource.selectDetail(getState(), label);
    }

    // force undefined as resource says it can be null
    return template || undefined;
  };

export const getDefaultTemplateId =
  (process: CreateOrTransfer): ThunkAction<Promise<?DefaultTemplate>> =>
  async (dispatch: Dispatch, getState: GetState) => {
    const sharingId = selectSetupOwner(getState());
    const label = actions.computeDefaultTemplateLabel(
      'domain',
      process,
      sharingId,
    );
    const isLoaded = resources.defaultTemplateResource.selectIsLoadedOne(
      getState(),
      {
        label,
      },
    );
    const isFailure = resources.defaultTemplateResource.selectIsFailureOne(
      getState(),
      {
        label,
      },
    );

    if (isLoaded || isFailure) {
      return selectors.defaultTemplateSelector(getState(), {
        productType: 'domain',
        process,
        sharingId,
      });
    }

    await dispatch(
      actions.fetchDefaultTemplate({
        productType: 'domain',
        process,
        sharingId,
      }),
    );

    return selectors.defaultTemplateSelector(getState(), {
      productType: 'domain',
      process,
      sharingId,
    });
  };
